/* Bastant site 2026 — forside: materialer (foto følger valgt finish), byg dit sæt (vælg dele + læg i kurv), nyhedsbrev (vis kvittering i den rigtige formular). */
(() => {
  if (window.BastantHome) return;
  window.BastantHome = true;

  const formatKr = (cents) => {
    const value = Math.round(Number(cents) || 0);
    const kr = Math.floor(value / 100);
    const ore = value % 100;
    const whole = String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${whole}${ore ? ',' + String(ore).padStart(2, '0') : ''} kr.`;
  };
  const routes = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Same flow as assets/bastant-lp.js: Impact's bundled sections + variant:add, so the cart drawer opens and the count updates. */
  async function addToCart(items, source) {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } })
    );
    const response = await fetch(`${routes()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sections.join(',') }),
    });
    let json = {};
    try { json = await response.json(); } catch (e) { json = {}; }
    if (!response.ok) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      throw new Error(json.description || json.message || 'Sættet kunne ikke lægges i kurven. Prøv igen om lidt.');
    }
    const settings = (window.themeVariables && window.themeVariables.settings) || {};
    if (settings.cartType === 'page') {
      window.location.href = `${routes()}cart`;
      return;
    }
    const cart = await (await fetch(`${routes()}cart.js`)).json();
    cart.sections = json.sections;
    (source || document.documentElement).dispatchEvent(
      new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart } })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } })
    );
  }

  /* ---------- Materialer ---------- */
  function initMaterials(root) {
    if (root.dataset.bsBound) return;
    root.dataset.bsBound = 'true';
    const rows = [...root.querySelectorAll('[data-bs-material]')];
    const frames = [...root.querySelectorAll('[data-bs-material-photo]')];
    const pill = root.querySelector('[data-bs-material-pill]');
    const pillText = root.querySelector('[data-bs-material-pill-text]');
    const pillSwatch = root.querySelector('[data-bs-material-pill-swatch]');
    if (!rows.length) return;

    const activate = (row) => {
      rows.forEach((r) => r.classList.toggle('is-active', r === row));
      const id = row.dataset.bsMaterial;
      const hasPhoto = frames.some((f) => f.dataset.bsMaterialPhoto === id);
      const target = hasPhoto ? id : frames[0] && frames[0].dataset.bsMaterialPhoto;
      frames.forEach((f) => f.classList.toggle('is-active', f.dataset.bsMaterialPhoto === target));
      if (pill && hasPhoto) {
        pillText.textContent = (pill.dataset.template || '').replace('[finish]', row.dataset.name || '');
        pillSwatch.className = `bs-swatch bs-home-materials__pill-swatch bs-swatch--${row.dataset.swatch}`;
      } else if (pill) {
        const first = rows[0];
        pillText.textContent = (pill.dataset.template || '').replace('[finish]', first.dataset.name || '');
        pillSwatch.className = `bs-swatch bs-home-materials__pill-swatch bs-swatch--${first.dataset.swatch}`;
      }
    };
    rows.forEach((row) => {
      row.addEventListener('mouseenter', () => activate(row));
      row.addEventListener('focus', () => activate(row));
    });
  }

  /* ---------- Byg dit sæt ---------- */
  function initSet(card) {
    if (card.dataset.bsBound) return;
    card.dataset.bsBound = 'true';
    const inputs = [...card.querySelectorAll('[data-bs-set-item]')];
    const totalEl = card.querySelector('[data-bs-set-total]');
    const summaryEl = card.querySelector('[data-bs-set-summary]');
    const button = card.querySelector('[data-bs-set-add]');
    const error = card.querySelector('[data-bs-set-error]');
    const template = card.dataset.template || '';
    const finish = card.dataset.finish || '';

    const update = () => {
      const chosen = inputs.filter((i) => i.checked && !i.disabled);
      const total = chosen.reduce((sum, i) => sum + Number(i.dataset.price || 0), 0);
      if (totalEl) totalEl.textContent = formatKr(total);
      if (summaryEl) summaryEl.textContent = template.replace('[antal]', chosen.length).replace('[finish]', finish);
      if (button) button.disabled = chosen.length === 0;
      inputs.forEach((i) => i.closest('.bs-home-set__line')?.classList.toggle('is-off', !i.checked && !i.disabled));
    };
    inputs.forEach((i) => i.addEventListener('change', update));

    button?.addEventListener('click', async () => {
      const items = inputs.filter((i) => i.checked && !i.disabled).map((i) => ({ id: Number(i.value), quantity: 1 }));
      if (!items.length) return;
      if (error) { error.hidden = true; error.textContent = ''; }
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      try {
        await addToCart(items, button);
      } catch (e) {
        if (error) { error.textContent = e.message; error.hidden = false; }
      } finally {
        button.setAttribute('aria-busy', 'false');
        update();
      }
    });
    update();
  }

  /* ---------- Nyhedsbrev ---------- */
  /* Shopify marks every customer form on the page as posted; it sends the visitor back to #<form id>.
     Only the form that was actually sent keeps its receipt or error. */
  function initNewsletter(box) {
    const id = box.dataset.bsNewsletter;
    const posted = /[?&](customer_posted|contact_posted)=/.test(window.location.search) || box.querySelector('[data-bs-newsletter-success], [data-bs-newsletter-error]');
    if (!posted) return;
    if (window.location.hash === `#${id}`) return;
    box.querySelector('[data-bs-newsletter-success]')?.setAttribute('hidden', '');
    box.querySelector('[data-bs-newsletter-error]')?.remove();
    box.querySelector('[data-bs-newsletter-fields]')?.removeAttribute('hidden');
    box.querySelector('[aria-invalid]')?.removeAttribute('aria-invalid');
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-bs-materials]').forEach(initMaterials);
    scope.querySelectorAll('[data-bs-set]').forEach(initSet);
    scope.querySelectorAll('[data-bs-newsletter]').forEach(initNewsletter);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
